import { Component, computed, inject } from '@angular/core';
import { AuthService } from '../../../services/auth';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-avatar',
  imports: [CommonModule],
  templateUrl: './avatar.html',
  styleUrl: './avatar.css',
})
export class Avatar {
  authService = inject(AuthService);
  avatarColor = '';
  userInitials = computed(() => {
    const user = this.authService.getUserInfo();
    if (!user) return '';
    const first = user.given_name?.charAt(0).toUpperCase() || '';
    const last = user.family_name?.charAt(0).toUpperCase() || '';
    return `${first}${last}`;
  });

  ngOnInit(): void {
    this.avatarColor = this.getDeterministicColor();
  }

  private getDeterministicColor(): string {
    const colors = [
      '#F87171',
      '#FBBF24',
      '#34D399',
      '#60A5FA',
      '#A78BFA',
      '#F472B6',
      '#FCD34D',
    ];
    const initials = this.userInitials();
    const hash = (initials || '').split('').reduce((sum, ch) => sum + ch.charCodeAt(0), 0);
    return colors[hash % colors.length];
  }
}
